import {
    APP__GET_COMMAND_LIST__START,
    APP__GET_COMMAND_LIST__SUCCESS,
    APP__GET_COMMAND_LIST__FAILURE,
    APP__GET_MERCHANT_LIST__START,
    APP__GET_MERCHANT_LIST__SUCCESS,
    APP__GET_MERCHANT_LIST__FAILURE,
    APP__RUN_COMMAND__START,
    APP__RUN_COMMAND__SUCCESS,
    APP__RUN_COMMAND__FAILURE,
} from './actions';

const initialState = {
    commandList: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    merchantList: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    commandState: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
        commandName: '',
    },
};
export default function AppReducer(state = initialState, action = {}) {
    switch (action.type) {
        case APP__GET_COMMAND_LIST__START: {
            return {
                ...state,
                commandList: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case APP__GET_COMMAND_LIST__SUCCESS: {
            return {
                ...state,
                commandList: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case APP__GET_COMMAND_LIST__FAILURE: {
            return {
                ...state,
                commandList: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case APP__GET_MERCHANT_LIST__START: {
            return {
                ...state,
                merchantList: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case APP__GET_MERCHANT_LIST__SUCCESS: {
            return {
                ...state,
                merchantList: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case APP__GET_MERCHANT_LIST__FAILURE: {
            return {
                ...state,
                merchantList: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case APP__RUN_COMMAND__START: {
            return {
                ...state,
                commandState: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                    commandName: action.commandName,
                },
            };
        }
        case APP__RUN_COMMAND__SUCCESS: {
            return {
                ...state,
                commandState: {
                    data: action.data.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                    commandName: action.commandName,
                },
            };
        }
        case APP__RUN_COMMAND__FAILURE: {
            return {
                ...state,
                commandState: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                    commandName: action.commandName,
                },
            };
        }

        default: {
            return state;
        }
    }
}
